<template>
    <sonicu-button
      @click="$emit('click', $event)"
    >
        <slot></slot>
    </sonicu-button>

</template>

<script>

import SonicuButton from "@/components/elements/buttons/SonicuButton";

export default {
    name: "ButtonBluePrimary",
    mixins: [],
    emits: ['click'],
    components: {SonicuButton},
    props: {
        
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>